import { doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type {
  ListMetricsResponse,
  MetricsRequest,
  MetricsResponse,
} from './types';

export const listMetrics = (accountId: string, projectId: string) => {
  return doGet<ListMetricsResponse>(
    `accounts/${accountId}/projects/${projectId}/aggregated_dashboards/metrics`,
    LOGGER_TYPE.ANALYTICS,
    { prefix: 'nebula' },
  );
};

export const queryMetrics = (
  accountId: string,
  projectId: string,
  body: MetricsRequest,
) => {
  return doPost<MetricsResponse>(
    `accounts/${accountId}/projects/${projectId}/metrics`,
    LOGGER_TYPE.ANALYTICS,
    body,
    { prefix: 'nebula' },
  );
};
